import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3119fb79"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-4 flex flex-col gap-6" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-lg" }, "Custom Fields", -1))
const _hoisted_3 = {
  key: 0,
  class: "min-h-300 gap-4 flex flex-col items-center justify-center"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Loading custom fields... ", -1))
const _hoisted_5 = { class: "flex items-center justify-between" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "text-sm" }
const _hoisted_8 = {
  key: 0,
  class: "flex gap-4 items-center"
}
const _hoisted_9 = {
  for: "search",
  class: "absolute left-2"
}
const _hoisted_10 = { class: "grid grid-cols-3 gap-5 mx-5 py-2 text-sm text-gray-500 border-b border-solid border-gray-300" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Field Name ", -1))
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Field Type ", -1))
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Tag ", -1))
const _hoisted_17 = { class: "flex justify-between items-center" }
const _hoisted_18 = { class: "flex justify-between items-center" }
const _hoisted_19 = { class: "flex justify-between items-center" }
const _hoisted_20 = {
  key: 1,
  class: "min-h-150 flex flex-col justify-center items-center gap-4"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "You have no fields in this group", -1))

import {
	useCustomFields,
	Field,
	readableFieldType,
	Group
} from '../composition/use-custom-fields';
import {
	UiLoader,
	SvgIcon,
	UiInput,
	UiButton
} from '@/ui-kit';
import { SortDirection } from '@/utils';
import { ref, reactive, computed } from 'vue';
import AddGroupDialog from '../components/AddGroupDialog.vue';
import AddCustomFieldDialog from '../components/AddCustomFieldDialog.vue';

type ColumnName = 'name' | 'type' | 'variable';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomFields',
  setup(__props) {

const { isLoading, groups, getFieldGroups } =
	useCustomFields();

const search = ref('');
const addGroupDialogRef =
	ref<InstanceType<typeof AddGroupDialog>>();
const addCustomFieldDialogRef =
	ref<InstanceType<typeof AddCustomFieldDialog>>();

getFieldGroups();

const openedGroups: Set<number> = reactive(
	new Set<number>([0])
);

const orderByMap: Map<number, [ColumnName, SortDirection]> =
	reactive(new Map());

function toggleGroup(id: number) {
	if (openedGroups.has(id)) {
		return openedGroups.delete(id);
	}

	openedGroups.add(id);
}

const customFieldsGroups = computed<Group[]>(() => {
	return [
		{
			id: 0,
			name: 'General',
			order: 0,
			fields: [
				{
					id: 1,
					name: 'Full Name',
					type: 'text',
					variable: 'name',
					order: 1,
					options: []
				},
				{
					id: 2,
					name: 'E-mail',
					type: 'text',
					variable: 'email',
					order: 2,
					options: []
				},
				{
					id: 3,
					name: 'Phone',
					type: 'text',
					variable: 'phone',
					order: 3,
					options: []
				},
				{
					id: 4,
					name: 'Fax',
					type: 'text',
					variable: 'fax_phone',
					order: 4,
					options: []
				},
				{
					id: 5,
					name: 'Address',
					type: 'text',
					variable: 'address',
					order: 5,
					options: []
				}
			]
		},
		...groups.value
	];
});

function variableText(variable: string): string {
	return `{{ ${variable} }}`;
}

function toggleSectionSort(
	group: number,
	column: ColumnName
) {
	const groupOrder = orderByMap.get(group);

	if (!groupOrder || groupOrder[0] !== column) {
		return orderByMap.set(group, [
			column,
			SortDirection.ASC
		]);
	}

	const [sortColumn, sortDirection] = groupOrder;

	if (sortDirection === SortDirection.ASC) {
		return orderByMap.set(group, [
			column,
			SortDirection.DESC
		]);
	}

	orderByMap.delete(group);
}

function sortArrowClasses(
	group: number,
	column: ColumnName
): string {
	const groupOrder = orderByMap.get(group);

	if (!groupOrder || groupOrder[0] !== column) {
		return 'rotate-90 opacity-75 group-hover:opacity-100 group-hover:text-dark-blue-400';
	}

	const [_, sortDirection] = groupOrder;

	return `opacity-100 text-dark-blue-400 ${
		sortDirection === SortDirection.ASC
			? 'rotate-90'
			: '-rotate-90'
	}`;
}

function sortBy(
	left: string,
	right: string,
	direction: SortDirection
): number {
	if (left > right) {
		return direction === SortDirection.ASC ? 1 : -1;
	}

	if (left < left) {
		return direction === SortDirection.ASC ? -1 : 1;
	}

	return 0;
}

function filterFields(fields: Field[]): Field[] {
	return fields.filter(
		(field) =>
			field.name
				.toLowerCase()
				.includes(
					search.value.toLowerCase().trim()
				) ||
			readableFieldType(field.type)
				.toLowerCase()
				.includes(
					search.value.toLowerCase().trim()
				) ||
			field.variable
				.toLowerCase()
				.includes(search.value.toLowerCase().trim())
	);
}

function getGroupFields(
	group: number,
	fields: Field[]
): Field[] {
	const groupOrder = orderByMap.get(group);

	if (!groupOrder) {
		return filterFields(fields);
	}

	const [column, direction] = groupOrder;

	return filterFields(fields).sort((left, right) => {
		switch (column) {
			case 'name': {
				return sortBy(
					left.name,
					right.name,
					direction
				);
			}
			case 'type': {
				return sortBy(
					left.type,
					right.type,
					direction
				);
			}
			case 'variable': {
				return sortBy(
					left.variable,
					right.variable,
					direction
				);
			}
			default: {
				return 0;
			}
		}
	});
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_unref(isLoading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_unref(UiLoader))
        ]))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(customFieldsGroups), (group) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "flex flex-col gap-2",
            key: group.id
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                onClick: ($event: any) => (toggleGroup(group.id)),
                class: "flex gap-2 items-center"
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["transform transition duration-100", [
								openedGroups.has(group.id)
									? 'rotate-90'
									: '-rotate-90'
							]])
                }, [
                  _createVNode(_unref(SvgIcon), {
                    name: "arrow",
                    class: "h-2.5 w-2.5"
                  })
                ], 2),
                _createElementVNode("span", _hoisted_7, _toDisplayString(group.name), 1)
              ], 8, _hoisted_6),
              (group.id === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_unref(UiInput), {
                      modelValue: search.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search).value = $event)),
                      name: "search",
                      class: "!mb-0 w-full max-w-sm search-input",
                      placeholder: "Search field"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("label", _hoisted_9, [
                          _createVNode(_unref(SvgIcon), {
                            class: "text-gray-300 h-4 w-4",
                            name: "search"
                          })
                        ]),
                        (search.value.length)
                          ? (_openBlock(), _createBlock(_unref(SvgIcon), {
                              key: 0,
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (search.value = '')),
                              class: "text-gray-300 cursor-pointer hover:text-gray-400 transition-all absolute right-2 h-4 w-4",
                              name: "close"
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_unref(UiButton), {
                      class: "!h-10 !text-sm !w-28 !min-w-28",
                      theme: "primary-outlined",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (
								addGroupDialogRef.value?.openDialog()
							))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Add Group ")
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(UiButton), {
                      class: "!h-10 !text-sm !w-28 !min-w-28",
                      theme: "primary",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (
								addCustomFieldDialogRef.value?.openDialog(
									null
								)
							))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Add Field ")
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            (openedGroups.has(group.id))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (group.fields.length)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("button", {
                            class: "flex justify-between items-center group",
                            onClick: ($event: any) => (
									toggleSectionSort(
										group.id,
										'name'
									)
								)
                          }, [
                            _hoisted_12,
                            _createElementVNode("div", {
                              class: _normalizeClass(["transform transition duration-100", 
										sortArrowClasses(
											group.id,
											'name'
										)
									])
                            }, [
                              _createVNode(_unref(SvgIcon), {
                                name: "arrow",
                                class: "h-3.5 w-3.5"
                              })
                            ], 2)
                          ], 8, _hoisted_11),
                          _createElementVNode("button", {
                            class: "flex justify-between items-center group",
                            onClick: ($event: any) => (
									toggleSectionSort(
										group.id,
										'type'
									)
								)
                          }, [
                            _hoisted_14,
                            _createElementVNode("div", {
                              class: _normalizeClass(["transform transition duration-100", 
										sortArrowClasses(
											group.id,
											'type'
										)
									])
                            }, [
                              _createVNode(_unref(SvgIcon), {
                                name: "arrow",
                                class: "h-3.5 w-3.5"
                              })
                            ], 2)
                          ], 8, _hoisted_13),
                          _createElementVNode("button", {
                            class: "flex justify-between items-center group",
                            onClick: ($event: any) => (
									toggleSectionSort(
										group.id,
										'variable'
									)
								)
                          }, [
                            _hoisted_16,
                            _createElementVNode("div", {
                              class: _normalizeClass(["transform transition duration-100", 
										sortArrowClasses(
											group.id,
											'variable'
										)
									])
                            }, [
                              _createVNode(_unref(SvgIcon), {
                                name: "arrow",
                                class: "h-3.5 w-3.5"
                              })
                            ], 2)
                          ], 8, _hoisted_15)
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getGroupFields(
								group.id,
								group.fields
							), (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: item.id,
                            class: "grid grid-cols-3 py-1 gap-5 px-5 text-sm"
                          }, [
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("span", null, _toDisplayString(item.name), 1)
                            ]),
                            _createElementVNode("div", _hoisted_18, [
                              _createElementVNode("span", null, _toDisplayString(_unref(readableFieldType)(
											item.type
										)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("span", null, _toDisplayString(variableText(
											item.variable
										)), 1)
                            ])
                          ]))
                        }), 128))
                      ], 64))
                    : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _hoisted_21,
                        _createVNode(_unref(UiButton), {
                          class: "!text-sm !min-h-w-32 !w-32 !h-8",
                          theme: "primary-outlined",
                          onClick: ($event: any) => (
								addCustomFieldDialogRef.value?.openDialog(
									group.id
								)
							)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Create First Field ")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]))
                ], 64))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
    _createVNode(AddGroupDialog, {
      ref_key: "addGroupDialogRef",
      ref: addGroupDialogRef,
      order: _unref(groups).length
    }, null, 8, ["order"]),
    _createVNode(AddCustomFieldDialog, {
      ref_key: "addCustomFieldDialogRef",
      ref: addCustomFieldDialogRef
    }, null, 512)
  ]))
}
}

})